export const QR_SIZES = [
  {
    size: "200x200",
    value: 200,
  },
  {
    size: "500x500",
    value: 500,
  },
  {
    size: "1000x1000",
    value: 1000,
  },
  {
    size: "1500x1500",
    value: 1500,
  },
  {
    size: "2000x2000",
    value: 2000,
  },
];
